"use client";

import Link from "next/link";

import { WHATSAPP_LINK } from "@/constants/links";
import { logEvent } from "@/services/firebase";

interface IScheduledAppointmentProps {
  className?: string;
  section?: string;
}

export const ScheduledAppointment = ({
  className = "",
  section = "scheduled-appointment",
}: IScheduledAppointmentProps) => {
  return (
    <Link
      className={`bg-primary text-white font-semibold px-6 py-3 rounded-md hover:bg-opacity-90 transition ${className}`}
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      role="button"
      aria-label="Agendar uma consulta pelo WhatsApp"
      onClick={() => logEvent("agendar_consulta_click", { section })}
    >
      Agendar Consulta
    </Link>
  );
};
